export default __webpack_public_path__ + "static/media/discord.254bd2c6.svg";